// extracted by mini-css-extract-plugin
export default {"Container":"loader_Container__WSEa4","Loader":"loader_Loader__z03v+","spin":"loader_spin__ePibB"};